<template>
  <div class="chat-input">
    <div class="input-container">
      <input
        v-if="currentAgent === 'not available yet'"
        type="file"
        class="file-upload"
        ref="fileInput"
        @change="handleFileUpload"
        accept="image/*"
      />
      <textarea
        v-model="newMessage"
        @keydown.ctrl.enter.prevent="sendMessage"
        placeholder="Tapez un message..."
      ></textarea>
      <button
        v-if="currentAgent === 'not available yet'"
        @click="$refs.fileInput.click()"
        class="send-button"
      >
        📎
      </button>
      <button @click="sendMessage" class="send-button">Envoyer</button>
    </div>
  </div>
</template>

<script>
import { ref, watch } from "vue";

export default {
  name: "ChatInput",
  props: {
    currentAgent: {
      type: String,
      default: "thomas",
    },
  },
  emits: ["send-message", "file-upload"],
  setup(props, { emit }) {
    const newMessage = ref("");

    watch(
      () => props.currentAgent,
      () => {
        newMessage.value = "";
      }
    );

    function sendMessage() {
      if (!newMessage.value.trim()) return;
      emit("send-message", newMessage.value);
      newMessage.value = "";
    }

    function handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        emit("file-upload", file);
      }
    }

    return {
      newMessage,
      sendMessage,
      handleFileUpload,
    };
  },
};
</script>

<style scoped>
.chat-input {
  padding: 1rem;
  border-top: 1px solid #e5e7eb;
}

.input-container {
  display: flex;
  gap: 0.5rem;
}

textarea {
  flex: 1;
  padding: 0.75rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  resize: none;
  min-height: 44px;
}

.send-button {
  padding: 0.75rem 1.5rem;
  background: var(--secondary);
  color: var(--secondary-content);
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.send-button:hover {
  background: #280052;
}

.file-upload {
  display: none;
}
</style>
